import { StarIcon } from '@heroicons/react/24/outline';
import { useSpotlight } from '../../hooks/useRespect';

/**
 * Dashboard card: lists up to 5 spotlight-level users (D-03).
 * Names come pre-formatted from the backend (formatUserName "Lastname Firstname").
 * No raw score shown — D-09 bands only on the public surface.
 * No "see all" / leaderboard link — D-03 explicitly forbids a sortable all-hands list.
 */
export function SpotlightCard() {
  const { data: entries = [], isLoading } = useSpotlight(5);

  return (
    <div className="rounded-xl bg-white shadow-sm border border-gray-200 p-5">
      <div className="flex items-center gap-2 mb-4">
        <StarIcon className="h-5 w-5 text-amber-500" aria-hidden="true" />
        <h2 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Spotlight</h2>
      </div>

      {isLoading ? (
        <ul className="space-y-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <li key={i} className="h-5 w-48 animate-pulse rounded bg-gray-100" />
          ))}
        </ul>
      ) : entries.length === 0 ? (
        <p className="text-sm text-gray-400">No spotlight users yet — check back soon.</p>
      ) : (
        <ul className="space-y-2">
          {entries.map((entry) => (
            <li key={entry.id} className="flex items-center gap-2">
              <StarIcon className="h-4 w-4 text-amber-400 flex-shrink-0" aria-hidden="true" />
              <span className="text-sm text-gray-800">{entry.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
